import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchChannelOrderTypes = createAsyncThunk("fetchChannelOrderTypes", async () => {
	const response = await axiosHttp.get(`common/categories?category_type=order_type`);
	return response.data.data;
});

const ChannelOrderTypeSlice = createSlice({
	name: "RewardProductTypesSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchChannelOrderTypes.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchChannelOrderTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchChannelOrderTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ChannelOrderTypeSlice.reducer;
